import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import {
    defineObbligatorietaSchedeSettore
} from '../../../../../features/schede-settore/shared/models/helpers/schede-settore.helpers';
import { getCoopTrasportoControl } from '../validators/helpers/coop-trasporto-form.helpers';

export const setSchedaCoopTrasportoSpecificListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_ModoDiAssociazione(form, store);
};

/** defineObbligatorietaSchedeSettore ricalcola l'obbligatorietà di TUTTE le 10 schede di
 * settore (non solo Trasporto) — vedi commento sulla funzione in schede-settore.helpers.ts. */
const my_ModoDiAssociazione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getCoopTrasportoControl(form, 'my_ModoDiAssociazione');
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe(() => {
        defineObbligatorietaSchedeSettore(form, store);
    });
};
